import { Link, NavLink } from 'react-router';
import { useChrome } from '../../lib/chrome';
import styles from './Header.module.css';

type Props = { title: string; social: { label: string; url: string }[] };

export function Header({ title, social }: Props) {
  const { overHero } = useChrome();
  return (
    <header className={styles.header} data-over-hero={overHero || undefined}>
      <nav className={styles.nav} aria-label="Main">
        <NavLink to="/" end className={styles.link}>
          Portfolio
        </NavLink>
        <NavLink to="/contact" className={styles.link}>
          Contact
        </NavLink>
      </nav>
      <Link to="/" className={styles.brand}>
        {title}
      </Link>
      <ul className={styles.social}>
        {social.map((s) => (
          <li key={s.url}>
            <a href={s.url} className={styles.link} target="_blank" rel="noreferrer">
              {s.label}
            </a>
          </li>
        ))}
      </ul>
    </header>
  );
}
